export default [
  {
    name: 'project_members_list',
    component_path: 'modules/templates/blocks/project/ProjectMembersList'
  }
]